<div class="me-forgot-password">
    <div class="me-forgot-password--body">
        <div class="klenico-me--background">
            <div class="klenico-me--background--inner"></div>
        </div>
        <div class="container me-forgot-password--body--content">
            <div class="me-forgot-password-form">
                <div class="me-forgot-password-form--header">
                    {{ 'Forgot password?' | translate}}
                </div>
                <div class="me-forgot-password-form--description" *ngIf="!showMessage">
                    {{ 'Enter your email address to reset your password' | translate}}
                </div>
                <div class="me-forgot-password-form--description" *ngIf="showMessage">
                    {{ 'If you have not received anything, please check your spam folder.' | translate}}
                </div>
                <form [formGroup]="form" *ngIf="!showMessage">
                    <div class="row">
                        <div class="col-xs-12 col-md-6">
                            <div class="me-form-input-group">
                                <div class="me-form-input" [class.error]="!(form.controls.email.valid
                                || (form.controls.email.pristine && !submitted))">
                                    <label class="me-form-input__label">{{ 'Email Address' | translate }}*</label>
                                    <input title="{{'Please fill out this field.' | translate}}" formControlName="email" class="me-form-input__input" />
                                </div>
                                <small [hidden]="form.controls.email.valid
                                || (form.controls.email.pristine && !submitted)"
                                class="me-form-input__error">
                                    {{ 'E-Mail address is required' | translate }}
                                </small>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="me-forgot-password-form--button" *ngIf="!showMessage">
                    <button class="btn btn--primary" [class.disabled]="!form.valid" (click)="submit(form.value, form.valid)">
                        {{'Reset password' | translate}}
                    </button>
                </div>
            </div>
            <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
                <span class="fas fa-exclamation-circle" aria-hidden="true"></span>{{ errorMessage | translate }}
            </div>
        </div>
    </div>
</div>